import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useCheckAuth } from "hooks/useCheckAuth";
import { PATHS } from "config/paths";

const AppWrapper = () => {
  const { isLoading, isAuthenticated } = useCheckAuth();
  const location = useLocation();
  console.log("refreshhhhhhhhhhhhhhhhhhhhhhhhhh");
  if (isLoading) return <div>Loading...</div>;

  const publicPaths = [
    "/",
    "/login",
    "/register",
    "/confirm-email",
    "/reset-password",
    "/payment",
    "/company",
    "/paiement-success",
    "/sign/:token",
  ];

  const isPublic = publicPaths.includes(location.pathname);

  // ⛔ If not authenticated and trying to access a private page → go to login
  if (!isAuthenticated && !isPublic) {
    return <Navigate to="/login" replace />;
  }

  // ✅ If authenticated and trying to access login/register/home → go to invoicesList
  if (
    isAuthenticated &&
    ["/login", "/register", "/"].includes(location.pathname)
  ) {
    return <Navigate to={PATHS.DASHBOARD_USER} replace />;
  }

  return <Outlet />;
};

export default AppWrapper;
